// react components

//ReactEcharts
import ReactEcharts from "echarts-for-react";

// react-router-dom components

// mui components

// mui-icons components

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
// import GraphLayout from "../layout/GraphLayout";

//routes

//assets

//common
// import RenderCharts from "../layout/RenderCharts";
//utils
import { AppendStatsToCharts } from "../../../utils/AppendStatsToCharts";

function HorizontalBarGraphs({ data = [] }) {
    const seriesData = AppendStatsToCharts(data);

    const labels = data.map((datum) => datum.title);
    const seriesBars = [
        {
            data: seriesData,
            type: "bar",
            barWidth: "80%",
            barGap: "-30%",
            barCategoryGap: "50%",
            emphasis: {
                itemStyle: {
                    shadowBlur: 20,
                    shadowOffsetX: 5,
                    shadowColor: "rgba(150, 150, 150, 0.7)",
                },
            },
        },
    ];

    const additionalLegends = labels.map((label) => ({
        name: label,
        type: "bar",
        data: [],
        itemStyle: {
            color: "#5470C6",
        },
    }));

    const series = seriesBars.concat(additionalLegends);

    const option = {
        tooltip: {
            trigger: "item",
            confine: true,
            formatter: function (params) {
                let tooltipText = `<div style="text-align: left;">${params.name}: ${params.value}`;
                if (params.data.details) {
                    tooltipText += params.data.details.map((detail) => `<br/>${detail.name} : <span style={{fontWeight: 600}}>${detail.value}</span>`).join("");
                }
                tooltipText += `</div>`;
                return tooltipText;
            },
            textStyle: {
                fontSize: 12,
            },
        },
        grid: {
            left: "35%",
            top: "20%",
            right: "10%",
            bottom: "10%",
        },
        legend: {
            top: "top",
            type: "scroll",
            selectedMode: false,
        },
        xAxis: {
            type: "value",
        },
        yAxis: {
            type: "category",
            data: labels,
        },
        series: series,
    };
    return (
        <div style={{ overflow: "auto" }}>
            <ReactEcharts
                option={option}
                style={{ minHeight: "350px", minWidth: "700px", height: "400px" }}
                opts={{ renderer: "svg" }}
            />
        </div>
    );
}

// Typechecking props for the HorizontalBarGraphs
HorizontalBarGraphs.propTypes = {
    data: PropTypes.array,
};

export default HorizontalBarGraphs;
